import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestNews from './components/LatestNews';
import HotRecommend from './components/HotRecommend';
import TopicSection from './components/TopicSection';
import BrandIntro from './components/BrandIntro';

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryEntries />
      <LatestNews />
      <HotRecommend />
      <TopicSection />
      <BrandIntro />
    </div>
  );
}